import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUpdateAvailable } from "@/lib/version-banner";

// Non-destructive "a new version is out" banner. Appears when the server reports
// a newer client bundle than the one this tab is running. The user reloads when
// ready (we never auto-reload, to avoid discarding a half-filled form).
export function UpdateBanner() {
  const updateAvailable = useUpdateAvailable();
  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border-t bg-primary px-4 py-2.5 text-sm text-primary-foreground shadow-lg"
      data-testid="banner-new-version"
    >
      <RefreshCw className="h-4 w-4 shrink-0" />
      <span>En ny versjon av todosystem er tilgjengelig.</span>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => window.location.reload()}
        data-testid="button-reload-new-version"
      >
        Last inn på nytt
      </Button>
    </div>
  );
}
